import { toggleTool } from 'components/pageElements/InspectionPage/AnnotationsTools';
import PDFTronManager from 'components/PDFViewer/PDFTronManager';
import { PDFManagerFactory } from 'pdftron';
import { getIsSingleFile, getManualSelectedZoneId, getSelectedTool, inspection } from 'store';
import store from 'store/store';
import { DocumentTypes, PDFTool, PDFTronTools } from 'types';

function canChangeTools(tool: PDFTool): boolean {
  const pdfDocManager = PDFManagerFactory?.getPDFDocManager();
  if (pdfDocManager) {
    return pdfDocManager.canChangeTools(tool);
  }
  return false;
}

function getWarningDescription(hasUnconfirmedZones: boolean, checkUnconfirmedGraphicZone: boolean) {
  let descriptionMessage: string;
  // Desciption message if it keeps populated more we can turn this to Switch case.
  if (checkUnconfirmedGraphicZone) {
    descriptionMessage = 'Oops! Please confirm the graphic zone before applying other markups.';
  } else if (hasUnconfirmedZones) {
    descriptionMessage = 'Oops! Please confirm the text zone before applying other markups.';
  } else {
    descriptionMessage =
      'Only one text tool can be used at a time. Please remove your other text markups and try again.';
  }

  return descriptionMessage;
}

export default function selectTool(tool: PDFTool): void {
  const state = store.getState();

  if (canChangeTools(tool)) {
    const instanceSource = PDFTronManager.getPDFInstance(DocumentTypes.source);
    const instanceTarget = PDFTronManager.getPDFInstance(DocumentTypes.target);

    const isSingleFile = getIsSingleFile(state);
    const selectedTool = getSelectedTool(state);
    const manualSelectedZoneId = getManualSelectedZoneId(state);

    const instancesNotNull = isSingleFile ? instanceTarget != null : instanceSource != null && instanceTarget != null;

    if (instancesNotNull) {
      // TODO To verify if this SELECTION_MODE is updated in the new version of PDFTron

      if (isSingleFile) {
        if (
          tool === PDFTronTools.GRAPHIC ||
          tool === PDFTronTools.CROSSOUT ||
          tool === PDFTronTools.MARQUEE_ZONE ||
          tool === PDFTronTools.MERGE_GRAPHICS_ZONE
        ) {
          // @ts-ignore
          instanceTarget.Core.Tools.TextTool.SELECTION_MODE = 'rectangular';
        } else {
          // @ts-ignore
          instanceTarget.Core.Tools.TextTool.SELECTION_MODE = 'structural';
        }
      } else {
        if (
          tool === PDFTronTools.GRAPHIC ||
          tool === PDFTronTools.CROSSOUT ||
          tool === PDFTronTools.MARQUEE_ZONE ||
          tool === PDFTronTools.CROP ||
          tool === PDFTronTools.RESYNC ||
          tool === PDFTronTools.MERGE_GRAPHICS_ZONE
        ) {
          // @ts-ignore
          instanceSource.Core.Tools.TextTool.SELECTION_MODE = 'rectangular';
          // @ts-ignore
          instanceTarget.Core.Tools.TextTool.SELECTION_MODE = 'rectangular';
        } else {
          // @ts-ignore
          instanceSource.Core.Tools.TextTool.SELECTION_MODE = 'structural';
          // @ts-ignore
          instanceTarget.Core.Tools.TextTool.SELECTION_MODE = 'structural';
        }
      }
      /* eslint-enable */
      if (tool !== selectedTool) {
        PDFManagerFactory.getPDFDocManager()?.highlightDocument(tool);
      } else {
        // reselecting a tool removes all panel highlight
        PDFManagerFactory.getPDFDocManager()?.cleanDocumentHighlight();
      }
    }

    // Exit polygon creation when changing away from polygon tool
    const activePolygonCreation = state.inspection.activePolygonCreation;
    if (activePolygonCreation.isActive && tool !== PDFTronTools.POLYGON) {
      store.dispatch(inspection.actions.exitPolygonCreation());
    }

    store.dispatch(
      inspection.actions.setSelectedTool({
        tool: toggleTool(tool, selectedTool, manualSelectedZoneId),
      }),
    );
  } else {
    const pdfDocManager = PDFManagerFactory?.getPDFDocManager();
    const checkUnconfirmedGraphicZone = pdfDocManager?.checkUnconfirmedGraphicZones() || false;
    const hasUnconfirmedZones = pdfDocManager?.hasUnconfirmedZones() || false;
    const errorMessage = getWarningDescription(hasUnconfirmedZones, checkUnconfirmedGraphicZone);
    store.dispatch(inspection.actions.setChangeToolError(errorMessage));
  }
}
